'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = require('@material-ui/core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = function styles(theme, props, style) {
    return typeof style === 'function' ? style(theme, props) : style;
};

var StyledComponent = function (_React$Component) {
    _inherits(StyledComponent, _React$Component);

    function StyledComponent() {
        _classCallCheck(this, StyledComponent);

        return _possibleConstructorReturn(this, (StyledComponent.__proto__ || Object.getPrototypeOf(StyledComponent)).apply(this, arguments));
    }

    _createClass(StyledComponent, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                classes = _props.classes,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                WrappedComponent = _props.WrappedComponent,
                sref = _props.sref,
                passThroughProps = _objectWithoutProperties(_props, ['classes', 'className', 'WrappedComponent', 'sref']);

            return _react2.default.createElement(WrappedComponent, _extends({
                classes: classes,
                className: (0, _classnames2.default)(classes[Object.keys(classes)[0]], className)
            }, passThroughProps, {
                ref: sref ? sref : undefined
            }));
        }
    }]);

    return StyledComponent;
}(_react2.default.Component);

StyledComponent.propTypes = {
    classes: _propTypes2.default.object.isRequired,
    className: _propTypes2.default.string
};

var styled = function styled(WrappedComponent) {
    var customProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return function (style) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var HOCProps = function HOCProps(WrappedComponent) {
            return function (_React$Component2) {
                _inherits(_HOCProps, _React$Component2);

                function _HOCProps() {
                    var _ref;

                    var _temp, _this2, _ret;

                    _classCallCheck(this, _HOCProps);

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = _HOCProps.__proto__ || Object.getPrototypeOf(_HOCProps)).call.apply(_ref, [this].concat(args))), _this2), _this2.FinalComponent = (0, _core.withStyles)(function (theme) {
                        return styles(theme, _this2.props, style);
                    }, options)(StyledComponent), _temp), _possibleConstructorReturn(_this2, _ret);
                }

                _createClass(_HOCProps, [{
                    key: 'render',
                    value: function render() {
                        return _react2.default.createElement(this.FinalComponent, _extends({}, customProps, this.props, { WrappedComponent: WrappedComponent }));
                    }
                }]);

                return _HOCProps;
            }(_react2.default.Component);
        };
        return HOCProps(WrappedComponent);
    };
};

exports.default = styled;